import {useMutation, useQueryClient} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {teamApi} from '../api';
import {teamKeys} from './useTeamMembersQuery';

import type {InviteMemberPayload} from '@sollapay/types';

export function useInviteMemberMutation() {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: InviteMemberPayload) => teamApi.inviteMember(client, payload),
    onSuccess: () => {
      // A new member also shifts their role's `memberCount`.
      queryClient.invalidateQueries({queryKey: teamKeys.members()});
      queryClient.invalidateQueries({queryKey: teamKeys.roles()});
    }
  });
}
